export default __webpack_public_path__ + "static/media/delete.f9f66adc.svg";